const bankModalSelector = '#income-bank-import-modal';

const escapeHtml = value => $('<div/>').text(value || '').html();

const debounce = (callback, wait) => {
    let timeoutId = null;

    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => callback(...args), wait);
    };
};

const showBankModalError = (modal, message) => {
    modal.find('.js-income-bank-import-alerts').first().html(`<div class="alert alert-danger">${escapeHtml(message)}</div>`);
};

const applyBankValidationErrors = (form, errors = {}) => {
    form.find('.parsley-errors-list.filled').remove();
    form.find('.parsley-error').removeClass('parsley-error');

    Object.entries(errors).forEach(([field, messages]) => {
        const message = Array.isArray(messages) ? messages[0] : messages;
        const input = form.find(`[name="${field}"]`).first();

        if (input.length) {
            input.addClass('parsley-error');
            input.closest('.form-group').append(`<ul class="parsley-errors-list filled width-full" aria-hidden="false"><li class="parsley-required">${escapeHtml(message)}</li></ul>`);
            return;
        }

        showBankModalError(form, message || 'Проверьте заполнение формы.');
    });
};

const initBankModalContent = modal => {
    window.initDynamicFormControls && window.initDynamicFormControls(modal);
    modal.find('.js-income-bank-line').each(function () {
        const line = $(this);
        toggleBankLineMode(line);
        queueBankLinkedIncomeDetails(line, 0);
    });
    setTimeout(() => {
        modal.find('.js-income-bank-line').each(function () {
            const line = $(this);
            toggleBankLineMode(line);
            queueBankLinkedIncomeDetails(line, 0);
        });
    }, 0);
    recalcBankTotals(modal);
};

const parseMoneyToKopecks = value => {
    const normalized = String(value || '').replace(/\s+/g, '').replace(',', '.');
    const number = Number(normalized);

    return Number.isFinite(number) ? Math.round(number * 100) : 0;
};

const formatMoney = kopecks => (kopecks / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function recalcBankTotals(root) {
    const container = $(root);
    const totalBox = container.find('.js-income-bank-total').first();
    if (!totalBox.length) {
        return;
    }

    const received = Number(totalBox.data('bank-amount')) || 0;
    let distributed = 0;
    container.find('.js-bank-line-amount').each(function () {
        distributed += parseMoneyToKopecks($(this).val());
    });

    const difference = received - distributed;
    totalBox.find('.js-bank-total-distributed').text(formatMoney(distributed));
    totalBox.find('.js-bank-total-difference').text(formatMoney(difference));
    totalBox.toggleClass('alert-success', difference === 0).toggleClass('alert-warning', difference !== 0);
    container.find('.js-income-bank-confirm-row').prop('disabled', difference !== 0);
}

const renumberLines = form => {
    form.find('.js-income-bank-line').each(function (index) {
        const line = $(this);
        line.attr('data-line-index', index);
        line.find('.js-bank-line-context').attr('data-line-index', index);
        line.find('.js-line-number').text(index + 1);
        line.find(':input[name]').each(function () {
            const input = $(this);
            input.attr('name', input.attr('name').replace(/lines\[\d+\]/, `lines[${index}]`));
        });
    });
};

const postRowForm = async (form, url) => {
    const data = form.serialize();
    return Axios.post(url, data);
};

function refreshBankSelectpicker(select) {
    if (select.data('selectpicker')) {
        select.selectpicker('refresh');
    }
}

function getBankSelectedOption(select) {
    const value = select.val();
    if (value === null || value === undefined || value === '') {
        return select.find('option[value=""]').first();
    }

    return select.find('option').filter(function () {
        return String($(this).attr('value')) === String(value);
    }).first();
}

function getBankSelectedValue(select) {
    const value = select.val();

    return value === null || value === undefined ? '' : String(value);
}

function syncBankSelectpickerChangedValue(select, event, clickedIndex, isSelected) {
    if (event.type !== 'changed' || typeof clickedIndex !== 'number' || isSelected === false) {
        return;
    }

    const option = select.find('option').eq(clickedIndex);
    if (option.length) {
        select.val(option.attr('value') || '');
    }
}

function hasBankSelectedContract(contract) {
    const selectedContract = getBankSelectedOption(contract);

    return Boolean(selectedContract.attr('value'))
        || Boolean(selectedContract.attr('data-property-id'))
        || Boolean(selectedContract.attr('data-client-id'));
}

function clearBankContractDerivedFields(line) {
    const property = line.find('.js-bank-line-property');
    const client = line.find('.js-bank-line-client');

    property.val('');
    client.val('');
    setBankSelectDisabled(property, false);
    setBankSelectDisabled(client, false);
    line.find('.js-bank-property-select-wrap, .js-bank-client-select-wrap').show();
    line.find('.js-bank-line-property-readonly, .js-bank-line-client-readonly').hide();
    line.find('.js-bank-contract-lock-note').addClass('d-none');
    refreshBankSelectpicker(property);
    refreshBankSelectpicker(client);
}

function resetBankContractOptions(contract) {
    contract.find('option').prop('hidden', false).prop('disabled', false);
}

function toggleBankLineMode(line, options = {}) {
    const action = line.find('.js-bank-line-action').val();
    const isSecurityDeposit = action === 'create_security_deposit' || action === 'link_existing_security_deposit';
    const isLinkExisting = action === 'link_existing' || action === 'link_existing_security_deposit';
    const isIncomeLinkExisting = action === 'link_existing';
    const contract = line.find('.js-bank-line-contract');
    const selectedContract = getBankSelectedOption(contract);
    const selectedContractValue = getBankSelectedValue(contract);
    const hasContract = hasBankSelectedContract(contract);
    const property = line.find('.js-bank-line-property');
    const client = line.find('.js-bank-line-client');
    const setSelectpickerDisabled = (select, disabled) => setBankSelectDisabled(select, disabled);

    line.find('.js-bank-create-only-field').toggle(!isLinkExisting);
    line.find('.js-bank-link-only-field').toggle(isLinkExisting);
    line.find('.js-bank-create-only-field :input').prop('disabled', isLinkExisting);
    line.find('.js-bank-link-only-field :input').prop('disabled', !isLinkExisting);
    line.find('[name$="[selected_duplicate_income_id]"]').prop('disabled', !isIncomeLinkExisting);
    line.find('[name$="[selected_security_deposit_movement_id]"]').prop('disabled', !isLinkExisting || !isSecurityDeposit);

    if (!isLinkExisting && hasContract) {
        const propertyId = selectedContract.attr('data-property-id');
        const clientId = selectedContract.attr('data-client-id');
        const propertyName = selectedContract.attr('data-property-name') || 'Объект из договора';
        const clientName = selectedContract.attr('data-client-name') || 'Контрагент из договора';

        if (selectedContractValue && contract.val() !== selectedContractValue) {
            contract.val(selectedContractValue);
        }
        property.val(propertyId);
        client.val(clientId);
        setSelectpickerDisabled(property, true);
        setSelectpickerDisabled(client, true);
        line.find('.js-bank-property-select-wrap, .js-bank-client-select-wrap').hide();
        line.find('.js-bank-line-property-readonly').text(propertyName).attr('title', propertyName).show();
        line.find('.js-bank-line-client-readonly').text(clientName).attr('title', clientName).show();
        line.find('.js-bank-contract-lock-note').removeClass('d-none');
    } else if (!isLinkExisting) {
        setSelectpickerDisabled(property, false);
        setSelectpickerDisabled(client, false);
        line.find('.js-bank-property-select-wrap, .js-bank-client-select-wrap').show();
        line.find('.js-bank-line-property-readonly, .js-bank-line-client-readonly').hide();
        line.find('.js-bank-contract-lock-note').addClass('d-none');
    }

    filterBankLineContracts(line);

    line.find('[name$="[income_group]"], [name$="[recognition_from]"], [name$="[recognition_to]"]')
        .closest('.form-group')
        .toggle(!isSecurityDeposit);
    line.find('[name$="[selected_duplicate_income_id]"]').toggle(!isSecurityDeposit);
    line.find('[name$="[selected_security_deposit_movement_id]"]').toggle(isSecurityDeposit);
    line.find('.js-bank-link-income-label').toggle(!isSecurityDeposit);
    line.find('.js-bank-link-security-deposit-label').toggle(isSecurityDeposit);

    const selectedIncomeInput = line.find('[name$="[selected_duplicate_income_id]"]');
    const selectedIncomeId = String(selectedIncomeInput.val() || '').trim();
    const incomeDetails = line.find('.js-bank-link-income-details');
    const hasIncomeDetails = String(incomeDetails.data('has-income-details')) === '1';
    const detailsIncomeId = String(incomeDetails.data('income-id') || '').trim();
    const showIncomeDetails = isIncomeLinkExisting && hasIncomeDetails && selectedIncomeId !== '' && selectedIncomeId === detailsIncomeId;
    const showIncomePending = isIncomeLinkExisting && !showIncomeDetails && selectedIncomeId !== '';
    incomeDetails.toggle(showIncomeDetails);
    line.find('.js-bank-link-income-pending').toggle(showIncomePending);

    line.find('select.selectpicker').each(function () {
        const select = $(this);
        if (options.skipContractRefresh && select.hasClass('js-bank-line-contract')) {
            return;
        }
        refreshBankSelectpicker(select);
    });
}

function getBankIncomeDetailsUrl(form, incomeId) {
    const template = form.data('income-details-url');

    return template ? String(template).replace('__income_id__', encodeURIComponent(incomeId)) : '';
}

function setBankIncomeDetailsState(details, hasDetails, incomeId = '', income = {}) {
    const incomeData = income || {};

    details
        .attr('data-has-income-details', hasDetails ? '1' : '0')
        .attr('data-income-id', incomeId || '')
        .attr('data-income-amount', hasDetails ? (incomeData.amount || '') : '')
        .attr('data-income-group', hasDetails ? (incomeData.income_group || '') : '')
        .attr('data-income-recognition-from', hasDetails ? (incomeData.recognition_from || '') : '')
        .attr('data-income-recognition-to', hasDetails ? (incomeData.recognition_to || '') : '')
        .data('has-income-details', hasDetails ? '1' : '0')
        .data('income-id', incomeId || '')
        .data('income-amount', hasDetails ? (incomeData.amount || '') : '')
        .data('income-group', hasDetails ? (incomeData.income_group || '') : '')
        .data('income-recognition-from', hasDetails ? (incomeData.recognition_from || '') : '')
        .data('income-recognition-to', hasDetails ? (incomeData.recognition_to || '') : '');
}

function getBankIncomeDetailsData(details) {
    return {
        amount: details.data('income-amount') || details.attr('data-income-amount') || '',
        income_group: details.data('income-group') || details.attr('data-income-group') || '',
        recognition_from: details.data('income-recognition-from') || details.attr('data-income-recognition-from') || '',
        recognition_to: details.data('income-recognition-to') || details.attr('data-income-recognition-to') || ''
    };
}

function applyBankLinkedIncomeValues(line, income = {}) {
    if (!income) {
        return;
    }

    if (Object.prototype.hasOwnProperty.call(income, 'amount') && income.amount !== '') {
        line.find('.js-bank-line-amount').val(income.amount);
    }

    if (Object.prototype.hasOwnProperty.call(income, 'income_group')) {
        line.find('.js-bank-line-income-group').val(income.income_group || '');
    }

    if (Object.prototype.hasOwnProperty.call(income, 'recognition_from')) {
        line.find('.js-bank-line-recognition-from').val(income.recognition_from || '');
    }

    if (Object.prototype.hasOwnProperty.call(income, 'recognition_to')) {
        line.find('.js-bank-line-recognition-to').val(income.recognition_to || '');
    }
}

function queueBankLinkedIncomeDetails(line, delay = 300) {
    clearTimeout(line.data('income-details-timeout'));
    line.data('income-details-timeout', setTimeout(() => refreshBankLinkedIncomeDetails(line), delay));
}

function invalidateBankLinkedIncomeDetailsRequest(line) {
    const sequence = (Number(line.data('income-details-request-sequence')) || 0) + 1;
    line.data('income-details-request-sequence', sequence);
}

async function refreshBankLinkedIncomeDetails(line) {
    const form = line.closest('.js-income-bank-row-form');
    const action = line.find('.js-bank-line-action').val();
    const selectedIncomeInput = line.find('[name$="[selected_duplicate_income_id]"]');
    const selectedIncomeId = String(selectedIncomeInput.val() || '').trim();
    const details = line.find('.js-bank-link-income-details').first();
    const pending = line.find('.js-bank-link-income-pending').first();

    if (!details.length) {
        return;
    }

    if (action !== 'link_existing') {
        invalidateBankLinkedIncomeDetailsRequest(line);
        return;
    }

    if (!selectedIncomeId) {
        details.empty().hide();
        setBankIncomeDetailsState(details, false);
        pending.removeClass('alert-danger').addClass('alert-light').text('Загрузка данных выбранного дохода…').hide();
        return;
    }

    if (String(details.data('has-income-details')) === '1' && String(details.data('income-id')) === selectedIncomeId) {
        applyBankLinkedIncomeValues(line, getBankIncomeDetailsData(details));
        recalcBankTotals(form);
        toggleBankLineMode(line);
        return;
    }

    const url = getBankIncomeDetailsUrl(form, selectedIncomeId);
    if (!url) {
        return;
    }

    const sequence = (Number(line.data('income-details-request-sequence')) || 0) + 1;
    line.data('income-details-request-sequence', sequence);
    details.hide();
    pending.removeClass('alert-danger').addClass('alert-light').text('Загрузка данных выбранного дохода…').show();

    try {
        const response = await Axios.get(url);
        if (sequence !== Number(line.data('income-details-request-sequence'))
            || String(selectedIncomeInput.val() || '').trim() !== selectedIncomeId
            || line.find('.js-bank-line-action').val() !== 'link_existing') {
            return;
        }

        const income = response.data.income || {};
        details.html(response.data.html || '');
        setBankIncomeDetailsState(details, true, selectedIncomeId, income);
        pending.hide();
        applyBankLinkedIncomeValues(line, income);
        recalcBankTotals(form);

        toggleBankLineMode(line);
    } catch (error) {
        if (sequence !== Number(line.data('income-details-request-sequence'))
            || String(selectedIncomeInput.val() || '').trim() !== selectedIncomeId
            || line.find('.js-bank-line-action').val() !== 'link_existing') {
            return;
        }

        const data = error.response && error.response.data ? error.response.data : {};
        const errors = data.errors || {};
        const message = (errors.selected_duplicate_income_id && errors.selected_duplicate_income_id[0])
            || data.message
            || 'Доход не найден или недоступен для текущего пользователя.';

        details.empty().hide();
        setBankIncomeDetailsState(details, false, selectedIncomeId);
        pending.removeClass('alert-light').addClass('alert-danger').text(message).show();
    }
}

function setBankSelectDisabled(select, disabled) {
    select.prop('disabled', disabled);

    const picker = select.data('selectpicker');
    if (picker) {
        refreshBankSelectpicker(select);

        if (picker.$button) {
            picker.$button
                .toggleClass('disabled', disabled)
                .prop('disabled', disabled)
                .attr('aria-disabled', disabled ? 'true' : 'false');
        }

        if (picker.$newElement) {
            picker.$newElement.toggleClass('disabled', disabled);
        }

        return;
    }

    const wrapper = select.closest('.bootstrap-select').length
        ? select.closest('.bootstrap-select')
        : select.next('.bootstrap-select');

    wrapper
        .toggleClass('disabled', disabled)
        .find('button.dropdown-toggle')
        .toggleClass('disabled', disabled)
        .prop('disabled', disabled)
        .attr('aria-disabled', disabled ? 'true' : 'false');
}

function filterBankLineContracts(line) {
    const contract = line.find('.js-bank-line-contract');

    if (!contract.length || hasBankSelectedContract(contract)) {
        return;
    }

    const propertyId = line.find('.js-bank-line-property').val();
    const clientId = line.find('.js-bank-line-client').val();

    resetBankContractOptions(contract);

    contract.find('option').each(function () {
        const option = $(this);
        if (!option.val()) {
            option.prop('hidden', false);
            option.prop('disabled', false);
            return;
        }

        const matchesProperty = !propertyId || String(option.attr('data-property-id')) === String(propertyId);
        const matchesClient = !clientId || String(option.attr('data-client-id')) === String(clientId);
        const visible = matchesProperty && matchesClient;
        option.prop('hidden', !visible);
        option.prop('disabled', !visible);
    });

    refreshBankSelectpicker(contract);
}

const previewBankDuplicates = (() => {
    let timeoutId = null;

    return form => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(async () => {
            const url = form.data('preview-duplicates-url');
            if (!url) {
                return;
            }

            try {
                const response = await Axios.post(url, form.serialize());
                form.find('.js-income-bank-duplicate-groups').html(response.data.html || '');
            } catch (error) {
                // Duplicate preview must not block the main editing flow.
            }
        }, 400);
    };
})();

const refreshBankLineContexts = (() => {
    let timeoutId = null;
    let requestSequence = 0;

    return (form, targetLine = null, delay = 300) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(async () => {
            const url = form.data('line-contexts-url');
            if (!url) {
                return;
            }

            const targetIndex = targetLine && targetLine.length ? Number(targetLine.attr('data-line-index')) : null;
            const targetLines = targetIndex === null
                ? form.find('.js-income-bank-line')
                : targetLine;

            targetLines.each(function () {
                const line = $(this);
                const context = line.find('.js-bank-line-context').first();
                const action = line.find('.js-bank-line-action').val();
                const hasContract = Boolean(getBankSelectedValue(line.find('.js-bank-line-contract')));
                const isLinkExisting = action === 'link_existing' || action === 'link_existing_security_deposit';

                if (!context.length) {
                    return;
                }

                if (!hasContract || isLinkExisting) {
                    context.empty();
                    return;
                }

                context.html('<div class="alert alert-light income-bank-line-context-loading m-b-10">Обновляем расчет…</div>');
            });

            const sequence = ++requestSequence;
            const data = targetIndex === null
                ? form.serialize()
                : `${form.serialize()}&target_index=${encodeURIComponent(targetIndex)}`;

            try {
                const response = await Axios.post(url, data);
                if (sequence !== requestSequence) {
                    return;
                }

                (response.data.contexts || []).forEach(context => {
                    const line = form.find(`.js-income-bank-line[data-line-index="${context.line_index}"]`).first();
                    line.find('.js-bank-line-context').first().html(context.html || '');
                });
            } catch (error) {
                targetLines.each(function () {
                    $(this).find('.js-bank-line-context').first().html('<div class="alert alert-warning m-b-10">Не удалось обновить расчет строки.</div>');
                });
            }
        }, delay);
    };
})();

const reloadRows = async () => {
    const dataTable = $('#income-bank-import-table');
    if (dataTable.length && $.fn.DataTable && $.fn.DataTable.isDataTable(dataTable)) {
        dataTable.DataTable().ajax.reload(null, false);
        return;
    }

    const container = $('.js-income-bank-import-rows').first();
    const url = container.data('rows-url');
    if (!container.length || !url) {
        return;
    }

    const response = await Axios.get(url);
    container.html(response.data.html || '');
};

const bankTableLanguage = {
    processing: 'Подождите...',
    search: 'Поиск:',
    lengthMenu: 'Показать _MENU_ записей',
    info: 'Записи с _START_ до _END_ из _TOTAL_ записей',
    infoEmpty: 'Записи с 0 до 0 из 0 записей',
    infoFiltered: '(отфильтровано из _MAX_ записей)',
    loadingRecords: 'Загрузка записей...',
    zeroRecords: 'Записи отсутствуют.',
    emptyTable: 'В таблице отсутствуют данные',
    paginate: {
        first: 'Первая',
        previous: 'Предыдущая',
        next: 'Следующая',
        last: 'Последняя'
    },
    aria: {
        sortAscending: ': активировать для сортировки столбца по возрастанию',
        sortDescending: ': активировать для сортировки столбца по убыванию'
    }
};

const initBankImportTable = () => {
    const table = $('#income-bank-import-table');
    if (!table.length || !$.fn.DataTable || $.fn.DataTable.isDataTable(table)) {
        return;
    }

    const periodFilter = $('#bank-import-period-filter');
    const customPeriod = $('#bank-import-custom-period');
    const dateFrom = $('#bank-import-date-from');
    const dateTo = $('#bank-import-date-to');
    const isCustomPeriod = () => periodFilter.val() === 'custom';
    const toggleCustomPeriod = () => customPeriod.toggleClass('d-none', !isCustomPeriod());
    const isCompleteDateValue = value => !value || /^\d{2}\.\d{2}\.\d{4}$/.test(value);
    const formatDateInput = value => {
        const digits = (value || '').replace(/\D/g, '').slice(0, 8);

        if (digits.length <= 2) {
            return digits;
        }

        if (digits.length <= 4) {
            return `${digits.slice(0, 2)}.${digits.slice(2)}`;
        }

        return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
    };
    const normalizeDateValue = value => {
        const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value || '');

        return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
    };

    if ($.fn.datepicker) {
        dateFrom.add(dateTo).datepicker({
            todayHighlight: true,
            autoclose: true,
            language: 'ru',
            format: 'dd.mm.yyyy',
            orientation: 'bottom auto',
            container: 'body'
        });
    }

    const dataTable = table.DataTable({
        processing: true,
        serverSide: true,
        searchDelay: 350,
        order: [[1, 'desc']],
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        scrollX: true,
        ajax: {
            url: table.data('url'),
            data: function (data) {
                $('.js-income-bank-import-filters .js-bank-filter').each(function () {
                    const input = $(this);
                    const name = input.attr('name');
                    data[name] = name === 'date_from' || name === 'date_to'
                        ? normalizeDateValue(input.val())
                        : input.val();
                });
            },
            dataSrc: function (json) {
                if (json.counts) {
                    $('.js-bank-count-active').text(`На разбор: ${json.counts.active}`);
                    $('.js-bank-count-duplicates').text(`С дублями: ${json.counts.duplicates}`);
                    $('.js-bank-count-confirmed').text(`Сохранено: ${json.counts.confirmed}`);
                    $('.js-bank-count-ignored').text(`Игнорировано: ${json.counts.ignored}`);
                    $('.js-bank-count-last-imported-payment-date').text(`Последний платеж: ${json.counts.last_imported_payment_date || '—'}`);
                }

                return json.data || [];
            }
        },
        columns: [
            { data: 'status', name: 'status', className: 'text-nowrap table-col-fixed' },
            { data: 'operation_date', name: 'operation_date', className: 'text-nowrap table-col-fixed' },
            { data: 'amount_display', name: 'amount', className: 'text-nowrap table-col-fixed' },
            { data: 'payer', name: 'payer', orderable: true, className: 'table-col-grow' },
            { data: 'payment_purpose', name: 'payment_purpose', className: 'table-col-grow' },
            { data: 'suggestion', name: 'suggestion', className: 'table-col-grow' },
            { data: 'duplicates', name: 'duplicates', className: 'text-nowrap' },
            { data: 'actions', name: 'actions', orderable: false, searchable: false, className: 'text-nowrap text-center table-col-actions' }
        ],
        language: bankTableLanguage,
        fixedHeader: {
            header: true,
            headerOffset: $('#header').height()
        }
    });

    const reloadIfValid = () => {
        if (!isCustomPeriod() || (isCompleteDateValue(dateFrom.val()) && isCompleteDateValue(dateTo.val()))) {
            dataTable.ajax.reload();
        }
    };

    $('.js-income-bank-import-filters').on('change input', '.js-bank-filter', debounce(reloadIfValid, 250));
    periodFilter.on('changed.bs.select change', function () {
        toggleCustomPeriod();
        if (!isCustomPeriod()) {
            dateFrom.val('');
            dateTo.val('');
        }
        reloadIfValid();
    });
    dateFrom.add(dateTo).on('input', function () {
        const formattedValue = formatDateInput($(this).val());
        if ($(this).val() !== formattedValue) {
            $(this).val(formattedValue);
        }
        reloadIfValid();
    });
    dateFrom.add(dateTo).on('changeDate change', reloadIfValid);

    toggleCustomPeriod();
};

const showPageSuccess = message => {
    if (!message) {
        return;
    }

    const alert = $('<div class="alert alert-success alert-dismissible fade show" role="alert"></div>').text(message);
    alert.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
    $('.content').first().prepend(alert);
};

$(function () {
    initBankImportTable();

    const storedMessage = window.sessionStorage ? window.sessionStorage.getItem('incomeBankImportMessage') : null;
    if (storedMessage) {
        window.sessionStorage.removeItem('incomeBankImportMessage');
        showPageSuccess(storedMessage);
    }

    $(document).on('click', '.js-income-bank-upload', async function (event) {
        event.preventDefault();
        const button = $(this);
        const modal = $(bankModalSelector);

        try {
            const response = await Axios.get(button.data('url') || button.attr('href'));
            modal.find('.js-income-bank-import-modal-title').text(response.data.title || 'Загрузка файла из банка');
            modal.find('.js-income-bank-import-modal-body').html(response.data.html || '');
            modal.modal('show');
            initBankModalContent(modal);
        } catch (error) {
            alert('Не удалось открыть форму загрузки файла.');
        }
    });

    $(document).on('submit', '.js-income-bank-upload-form', async function (event) {
        event.preventDefault();
        const form = $(this);
        const submit = form.find('[type="submit"]');
        const formData = new FormData(this);

        submit.prop('disabled', true);
        form.find('.js-income-bank-import-alerts').empty();

        try {
            const response = await Axios.post(form.attr('action'), formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (response.data.redirect_url) {
                if (window.sessionStorage && response.data.message) {
                    window.sessionStorage.setItem('incomeBankImportMessage', response.data.message);
                }
                window.location.href = response.data.redirect_url;
                return;
            }
        } catch (error) {
            const data = error.response && error.response.data ? error.response.data : {};
            const errors = data.errors || {};

            applyBankValidationErrors(form, errors);
            if (data.message && !Object.keys(errors).length) {
                showBankModalError(form, data.message);
            }
        } finally {
            submit.prop('disabled', false);
        }
    });

    $(document).on('click', '.js-income-bank-review-row', async function () {
        const button = $(this);
        const modal = $(bankModalSelector);

        try {
            const response = await Axios.get(button.data('url'));
            modal.find('.js-income-bank-import-modal-title').text(response.data.title || 'Разбор банковского платежа');
            modal.find('.js-income-bank-import-modal-body').html(response.data.html || '');
            modal.modal('show');
            initBankModalContent(modal);
        } catch (error) {
            alert('Не удалось открыть строку импорта.');
        }
    });

    $(document).on('input', '.js-bank-line-amount', function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const line = $(this).closest('.js-income-bank-line');
        recalcBankTotals(form);
        previewBankDuplicates(form);
        refreshBankLineContexts(form, line);
    });

    $(document).on('change', '.js-bank-line-action', function () {
        const line = $(this).closest('.js-income-bank-line');
        const form = $(this).closest('.js-income-bank-row-form');
        toggleBankLineMode(line);
        if ($(this).val() !== 'link_existing') {
            invalidateBankLinkedIncomeDetailsRequest(line);
        }
        queueBankLinkedIncomeDetails(line, 0);
        recalcBankTotals(form);
        previewBankDuplicates(form);
        refreshBankLineContexts(form, line, 0);
    });

    $(document).on('changed.bs.select change', '.js-bank-line-contract', function (event, clickedIndex, isSelected) {
        const line = $(this).closest('.js-income-bank-line');
        const form = $(this).closest('.js-income-bank-row-form');
        const input = $(this);

        if (event.type === 'change' && input.data('selectpicker')) {
            return;
        }

        syncBankSelectpickerChangedValue(input, event, clickedIndex, isSelected);

        if (!getBankSelectedValue(input)) {
            clearBankContractDerivedFields(line);
            resetBankContractOptions(input);
        }

        toggleBankLineMode(line, { skipContractRefresh: true });
        previewBankDuplicates(form);
        refreshBankLineContexts(form, line, 0);
    });

    $(document).on('changed.bs.select change', '.js-bank-line-property, .js-bank-line-client', function (event, clickedIndex, isSelected) {
        const line = $(this).closest('.js-income-bank-line');
        const form = $(this).closest('.js-income-bank-row-form');
        const input = $(this);

        if (event.type === 'change' && input.data('selectpicker')) {
            return;
        }

        syncBankSelectpickerChangedValue(input, event, clickedIndex, isSelected);

        filterBankLineContracts(line);
        toggleBankLineMode(line);
        previewBankDuplicates(form);
        refreshBankLineContexts(form, line, 0);
    });

    $(document).on('change input', '.js-bank-line-income-group, .js-bank-line-recognition-from, .js-bank-line-recognition-to', function () {
        const line = $(this).closest('.js-income-bank-line');
        const form = line.closest('.js-income-bank-row-form');

        refreshBankLineContexts(form, line);
    });

    $(document).on('input change', '[name$="[selected_duplicate_income_id]"], [name$="[selected_security_deposit_movement_id]"]', function () {
        const line = $(this).closest('.js-income-bank-line');
        toggleBankLineMode(line);
        if ($(this).attr('name').indexOf('[selected_duplicate_income_id]') !== -1) {
            queueBankLinkedIncomeDetails(line);
        }
    });

    $(document).on('click', '.js-income-bank-add-line', function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const lines = form.find('.js-income-bank-lines');
        const clone = lines.find('.js-income-bank-line').last().clone();

        clone.find('.bootstrap-select').each(function () {
            const wrapper = $(this);
            const select = wrapper.find('select').first();

            if (select.length) {
                wrapper.replaceWith(select);
            }
        });

        clone.find('input[type="text"], input[type="number"]').val('');
        clone.find('input[type="date"]').each(function () {
            const original = lines.find('.js-income-bank-line').first().find(`[name$="[${$(this).attr('name').split('][').pop()}"]`).val();
            $(this).val(original || '');
        });
        clone.find('select').each(function () {
            const select = $(this);
            select.removeData('selectpicker')
                .removeClass('bs-select-hidden')
                .removeAttr('data-id')
                .prop('disabled', false);
            select.find('option').prop('hidden', false).prop('disabled', false);
            select.val(select.find('option').first().val());
        });
        clone.find('.js-bank-property-select-wrap, .js-bank-client-select-wrap').show();
        clone.find('.js-bank-line-property-readonly, .js-bank-line-client-readonly').hide();
        clone.find('.js-bank-contract-lock-note').addClass('d-none');
        clone.find('.js-bank-link-income-details')
            .attr('data-has-income-details', '0')
            .attr('data-income-id', '')
            .attr('data-income-amount', '')
            .attr('data-income-group', '')
            .attr('data-income-recognition-from', '')
            .attr('data-income-recognition-to', '')
            .data('has-income-details', '0')
            .data('income-id', '')
            .data('income-amount', '')
            .data('income-group', '')
            .data('income-recognition-from', '')
            .data('income-recognition-to', '')
            .empty()
            .hide();
        clone.find('.js-bank-link-income-pending').hide();
        clone.find('.js-bank-line-context').empty();
        lines.append(clone);
        renumberLines(form);
        initBankModalContent(form);
        previewBankDuplicates(form);
        refreshBankLineContexts(form, null, 0);
    });

    $(document).on('click', '.js-income-bank-remove-line', function () {
        const form = $(this).closest('.js-income-bank-row-form');
        if (form.find('.js-income-bank-line').length <= 1) {
            alert('Должна остаться хотя бы одна строка распределения.');
            return;
        }

        $(this).closest('.js-income-bank-line').remove();
        renumberLines(form);
        recalcBankTotals(form);
        previewBankDuplicates(form);
        refreshBankLineContexts(form, null, 0);
    });

    $(document).on('click', '.js-income-bank-save-draft', async function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const button = $(this);
        button.prop('disabled', true);

        try {
            const response = await postRowForm(form, form.data('update-url'));
            form.closest('.js-income-bank-import-modal-body').html(response.data.html || '');
            initBankModalContent($(bankModalSelector));
            await reloadRows();
        } catch (error) {
            const data = error.response && error.response.data ? error.response.data : {};
            applyBankValidationErrors(form, data.errors || {});
            if (data.message) {
                showBankModalError(form, data.message);
            }
        } finally {
            button.prop('disabled', false);
        }
    });

    $(document).on('click', '.js-income-bank-confirm-row', async function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const button = $(this);
        button.prop('disabled', true);

        try {
            const response = await postRowForm(form, form.data('confirm-url'));
            $(bankModalSelector).modal('hide');
            await reloadRows();
            alert(response.data.message || 'Строка подтверждена.');
        } catch (error) {
            const data = error.response && error.response.data ? error.response.data : {};
            applyBankValidationErrors(form, data.errors || {});
            if (data.message) {
                showBankModalError(form, data.message);
            }
        } finally {
            button.prop('disabled', false);
        }
    });

    $(document).on('click', '.js-income-bank-ignore-row', async function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const reason = form.find('.js-income-bank-ignore-reason').val();
        if (!reason) {
            alert('Укажите причину игнорирования строки.');
            return;
        }

        try {
            const response = await Axios.post(form.data('ignore-url'), { ignored_reason: reason });
            $(bankModalSelector).modal('hide');
            await reloadRows();
            alert(response.data.message || 'Строка проигнорирована.');
        } catch (error) {
            const data = error.response && error.response.data ? error.response.data : {};
            showBankModalError(form, data.message || 'Не удалось проигнорировать строку.');
        }
    });

    $(document).on('click', '.js-income-bank-apply-preset', async function () {
        const button = $(this);
        const form = button.closest('.js-income-bank-row-form');

        try {
            const response = await Axios.post(button.data('url'));
            form.closest('.js-income-bank-import-modal-body').html(response.data.html || '');
            initBankModalContent($(bankModalSelector));
        } catch (error) {
            showBankModalError(form, 'Не удалось применить вариант распределения.');
        }
    });

    $(document).on('click', '.js-income-bank-preset-full-rent', function () {
        const form = $(this).closest('.js-income-bank-row-form');
        const amount = form.find('.js-income-bank-total').data('bank-amount');
        const first = form.find('.js-income-bank-line').first();
        form.find('.js-income-bank-line').not(first).remove();
        first.find('.js-bank-line-amount').val((amount / 100).toFixed(2));
        renumberLines(form);
        recalcBankTotals(form);
        refreshBankLineContexts(form, first, 0);
    });

    $(document).on('click', '.js-income-bank-link-duplicate', function () {
        const button = $(this);
        const form = button.closest('.js-income-bank-row-form');
        const targetIndex = String(button.data('line-index'));
        const firstLine = form.find(`.js-income-bank-line[data-line-index="${targetIndex}"]`).first();

        if (!firstLine.length) {
            alert('Не удалось определить строку распределения для связи с доходом.');
            return;
        }

        const candidateType = String(button.data('candidate-type') || 'income');
        if (candidateType === 'security_deposit') {
            firstLine.find('[name$="[action]"]').val('link_existing_security_deposit');
            firstLine.find('[name$="[selected_security_deposit_movement_id]"]').val(button.data('security-deposit-movement-id'));
            firstLine.find('[name$="[selected_duplicate_income_id]"]').val('');
        } else {
            firstLine.find('[name$="[action]"]').val('link_existing');
            firstLine.find('[name$="[selected_duplicate_income_id]"]').val(button.data('income-id'));
            firstLine.find('[name$="[selected_security_deposit_movement_id]"]').val('');
        }
        firstLine.find('.js-bank-line-amount').val(button.data('amount'));
        toggleBankLineMode(firstLine);
        queueBankLinkedIncomeDetails(firstLine, 0);
        recalcBankTotals(form);
        refreshBankLineContexts(form, firstLine, 0);
        form.find('.js-income-bank-import-alerts').html(candidateType === 'security_deposit'
            ? '<div class="alert alert-info">Выбрано существующее движение обеспечительного. Новая операция создана не будет.</div>'
            : '<div class="alert alert-info">Выбран существующий доход для связи. Нажмите «Сохранить» — новый доход создан не будет.</div>');
    });
});
